import { useHeadlessConsentUI } from "@c15t/nextjs"
import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react"
import { cn } from "./ui/cn"

export interface CookieSettingsLinkProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode
}

/**
 * Trigger that opens the preference-center dialog when clicked. Renders an
 * unstyled `<button>` so callers can style it however they need (footer
 * NavLink, menu item, etc.). Must render inside <ConsentProvider>.
 */
export const CookieSettingsLink = forwardRef<HTMLButtonElement, CookieSettingsLinkProps>(
  ({ className, onClick, type = "button", children, ...props }, ref) => {
    const ui = useHeadlessConsentUI()
    return (
      <button
        ref={ref}
        type={type}
        className={cn(className)}
        onClick={event => {
          onClick?.(event)
          if (!event.defaultPrevented) ui.openDialog()
        }}
        {...props}
      >
        {children}
      </button>
    )
  },
)
CookieSettingsLink.displayName = "CookieSettingsLink"
